import { useRef, useEffect, useState } from "react";
import { DataGridPro } from "@mui/x-data-grid-pro";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Box,
  Container,
  Checkbox,
  Chip,
  Divider,
  FormControlLabel,
  Stack,
  Typography,
  TextField,
} from "@mui/material";
import { CustomButton, CustomTypography } from "src/components/inputs";
// Icons
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export const dataGridStyle = {
  fontFamily: "tmwCustomFont",
  "& .MuiDataGrid-columnHeaders": {
    borderRadius: 0,
    borderBottom: "1px solid #E6E6E6",
  },
  "& .MuiInputBase-input": {
    fontSize: 12,
    fontWeight: 500,
  },
  "& .MuiDataGrid-columnHeaderTitle": {
    fontWeight: 600,
  },
  "& .MuiDataGrid-columnHeader:not(:first-of-type)": {
    borderLeft: "1px solid #E6E6E6",
  },
  "& .MuiDataGrid-cell": {
    borderLeft: "1px solid #E6E6E6",
    letterSpacing: 1,
    fontSize: 12,
    fontWeight: 400,
  },
  "& .MuiDataGrid-cell:last-child": {
    borderRight: "1px solid #E6E6E6",
  },
  "& .MuiDataGrid-row:not(:last-child)": {
    paddingTop: "1px",
    borderBottom: "1px solid #E6E6E6",
  },
  "& .MuiDataGrid-columnSeparator": {
    opacity: "0 !important",
  },
  "& .first-header-style": {
    borderTop: "1px solid #E6E6E6",
    borderLeft: "1px solid #E6E6E6 !important",
  },
  "& .last-header-style": {
    borderTop: "1px solid #E6E6E6",
    borderRight: "1px solid #E6E6E6 !important",
  },
  "& .header-style": {
    borderTop: "1px solid #E6E6E6",
    letterSpacing: 2,
    fontSize: 10,
    fontWeight: 600,
    textTransform: "uppercase",
    backgroundColor: "black",
    color: "white",
  },
  "& .actions": {
    borderLeft: "1px solid #E6E6E6",
    display: "flex",
    justifyContent: "space-around",
  },
  "& .header-actions": {
    fontSize: 7,
  },
  "& .MuiDataGrid-footerContainer": {
    letterSpacing: 2,
    textTransform: "uppercase",
  },
  "& .MuiTablePagination-selectLabel": {
    fontSize: 11,
    letterSpacing: 1,
  },
  "& .MuiTablePagination-displayedRows": {
    fontSize: 11,
    letterSpacing: 1,
  },
  "& .MuiTablePagination-select": {
    fontSize: 11,
    letterSpacing: 1,
  },
  "& .MuiDataGrid-virtualScroller": {
    borderBottom: "1px solid #E6E6E6",
    letterSpacing: 2,
    fontSize: 10,
    fontWeight: 600,
    minHeight: "50px",
  },
};

export const AssetsViewHistoryModal = (props) => {
  const modalRef = useRef(null);
  const isOpen = props?.isOpen;

  // Get Path
  const path = props?.path ? props.path : "/";

  // Get Assets Spaces Api History Log
  const assetsSpacesApiHistoryLogs = props?.histories;

  // Get Assets Spaces Api History Log Types
  const assetsSpacesApiHistoryLogTypes =
    assetsSpacesApiHistoryLogs?.spacesHistoryLogTypes;

  // Tab 0 - Current Folder Path - Assets History Logs
  let currentFolderPathLogs =
    assetsSpacesApiHistoryLogs?.spacesApiHistoryLogs?.filter(
      (object) =>
        (object.path.endsWith("/") ? object.path : object.path + "/") === path
    );

  // Tab 1 - All Folders - Assets History Logs
  let allFoldersLogs = assetsSpacesApiHistoryLogs?.spacesApiHistoryLogs?.map(
    (obj) => ({
      ...obj,
      path: obj.path.endsWith("/") ? obj.path : obj.path + "/",
    })
  );

  //
  // Tabs
  //

  const [tab, setTab] = useState(0);

  //
  // Acordion
  //

  const [expandedPanel, setExpandedPanel] = useState(null);

  //
  // Type - Filter
  //

  const [selectedType, setSelectedType] = useState(null);

  const handleExpandChange = (id) => (event, isExpanded) => {
    setExpandedPanel(isExpanded ? id : null);
  };

  // Date Options
  const dateOptions = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
    formatMatcher: "basic",
  };

  useEffect(() => {
    if (isOpen) {
      modalRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [isOpen]);

  //
  // Filtering - Type
  //

  if (selectedType) {
    // Curent Folder Path Logs
    currentFolderPathLogs = currentFolderPathLogs.filter(
      (currentFolderPathLog) => currentFolderPathLog.type === selectedType
    );

    // All Folders Logs
    allFoldersLogs = allFoldersLogs.filter(
      (allFoldersLog) => allFoldersLog.type === selectedType
    );
  }

  //
  // Table Settings
  //

  // Checkbox Cell for Existing/Overwrite/New File Columns
  const renderCheckboxCell = (params) => {
    // Case 1: null
    if (params.value === null) {
      return <span>N/A</span>;
    }

    // Case 2: Boolean
    if (typeof params.value === "boolean")
      return (
        <div>
          <FormControlLabel
            control={<Checkbox checked={params.value} value={params.value} />}
            disabled
          />
        </div>
      );
  };

  const columnsDefinition = (type) => {
    // 1. Create Folder - Table Columns
    if (type === assetsSpacesApiHistoryLogTypes.createFolder) {
      const createFolderColumns = [
        {
          field: "index",
          headerName: "N°",
          headerClassName: "first-header-style header-style",
          width: 50,
          editable: false,
          type: "number",
          headerAlign: "center",
        },
        {
          field: "folderName",
          headerName: "Folder Name",
          headerClassName: "header-style last-header-style",
          flex: 1,
          editable: false,
          headerAlign: "center",
        },
      ];

      return createFolderColumns;
    }

    // 2. Delete Folder - Table Columns
    if (type === assetsSpacesApiHistoryLogTypes.deleteFolder) {
      const deleteFolderColumns = [
        {
          field: "index",
          headerName: "N°",
          headerClassName: "first-header-style header-style",
          width: 50,
          editable: false,
          type: "number",
          headerAlign: "center",
        },
        {
          field: "folderName",
          headerName: "Folder Name",
          headerClassName: "header-style last-header-style",
          flex: 1,
          editable: false,
          headerAlign: "center",
        },
      ];

      return deleteFolderColumns;
    }

    // 3. Delete File - Table Columns
    if (type === assetsSpacesApiHistoryLogTypes.deleteFile) {
      const deleteFileColumns = [
        {
          field: "index",
          headerName: "N°",
          headerClassName: "first-header-style header-style",
          width: 50,
          editable: false,
          type: "number",
          headerAlign: "center",
        },
        {
          field: "filename",
          headerName: "Filename",
          headerClassName: "header-style last-header-style",
          flex: 1,
          editable: false,
          headerAlign: "center",
        },
      ];

      return deleteFileColumns;
    }

    // 4. Delete Multiple Files - Table Columns
    if (type === assetsSpacesApiHistoryLogTypes.deleteMultipleFiles) {
      const deleteMultipleFilesColumns = [
        {
          field: "index",
          headerName: "N°",
          headerClassName: "first-header-style header-style",
          width: 50,
          editable: false,
          type: "number",
          headerAlign: "center",
        },
        {
          field: "filename",
          headerName: "Filename",
          headerClassName: "header-style last-header-style",
          flex: 1,
          editable: false,
          headerAlign: "center",
        },
      ];

      return deleteMultipleFilesColumns;
    }

    // 5. Upload Files - Table Columns
    if (type === assetsSpacesApiHistoryLogTypes.uploadFiles) {
      const uploadFilesColumns = [
        {
          field: "index",
          headerName: "N°",
          headerClassName: "first-header-style header-style",
          width: 50,
          editable: false,
          type: "number",
          headerAlign: "center",
        },
        {
          field: "uploadFilename",
          headerName: "Upload Filename",
          headerClassName: "header-style",
          flex: 1,
          editable: false,
          headerAlign: "center",
        },
        {
          field: "finalFilename",
          headerName: "Final Filename",
          headerClassName: "header-style",
          flex: 1,
          editable: false,
          headerAlign: "center",
        },
        {
          field: "existing",
          headerName: "Existing",
          headerClassName: "header-style",
          width: 100,
          editable: false,
          headerAlign: "center",
          renderCell: (params) => renderCheckboxCell(params),
        },
        {
          field: "overwrite",
          headerName: "Overwrite",
          headerClassName: "header-style",
          width: 100,
          editable: false,
          headerAlign: "center",
          renderCell: (params) => renderCheckboxCell(params),
        },
        {
          field: "newFile",
          headerName: "New File",
          headerClassName: "header-style last-header-style",
          width: 100,
          editable: false,
          headerAlign: "center",
          renderCell: (params) => renderCheckboxCell(params),
        },
      ];

      return uploadFilesColumns;
    }

    return [];
  };

  const columnGroupingModel = (type) => {
    // 1. Upload Files - Table Columns Grouping
    if (type === assetsSpacesApiHistoryLogTypes.uploadFiles) {
      const columnGroupingModel = [
        {
          groupId: "Duplicate Choice",
          children: [{ field: "overwrite" }, { field: "newFile" }],
          headerAlign: "center",
          headerClassName: "header-style",
        },
      ];

      return columnGroupingModel;
    }

    return [];
  };

  const rowsParser = (type, data) => {
    // 1. Create Folder - Row Parser
    if (
      type === assetsSpacesApiHistoryLogTypes.createFolder &&
      data?.length > 0
    ) {
      const createFolderParsedRows = data.map((str, index) => ({
        index: index + 1,
        folderName: str,
      }));

      return createFolderParsedRows;
    }

    // 2. Delete Folder - Row Parser
    if (
      type === assetsSpacesApiHistoryLogTypes.deleteFolder &&
      data?.length > 0
    ) {
      const deleteFolderParsedRows = data.map((str, index) => ({
        index: index + 1,
        folderName: str,
      }));

      return deleteFolderParsedRows;
    }

    // 3. Delete File - Row Parser
    if (
      type === assetsSpacesApiHistoryLogTypes.deleteFile &&
      data?.length > 0
    ) {
      const deleteFileParsedRows = data.map((str, index) => ({
        index: index + 1,
        filename: str,
      }));

      return deleteFileParsedRows;
    }

    // 4. Delete Multiple Files - Row Parser
    if (
      type === assetsSpacesApiHistoryLogTypes.deleteMultipleFiles &&
      data?.length > 0
    ) {
      const deleteMultipleFilesParsedRows = data.map((str, index) => ({
        index: index + 1,
        filename: str,
      }));

      return deleteMultipleFilesParsedRows;
    }

    // 5. Upload Files - Row Parser
    if (
      type === assetsSpacesApiHistoryLogTypes.uploadFiles &&
      data?.length > 0
    ) {
      // Case 1: String

      const uploadFilesParsedRows = data.map((item, index) => {
        // Case 1: String
        if (typeof item === "string") {
          const uploadFilesString = {
            index: index + 1,
            uploadFilename: item,
            finalFilename: item,
            existing: null,
            overwrite: null,
            newFile: null,
          };

          return uploadFilesString;
        }

        // Case 2: Object
        if (typeof item === "object" && item !== null) {
          const uploadFilesObject = {
            index: index + 1,
            uploadFilename: item.uploadFilename,
            finalFilename: item.finalFilename,
            existing: item.existing,
            overwrite: item.duplicateChoice.overwrite,
            newFile: item.duplicateChoice.newFile,
          };

          return uploadFilesObject;
        }
      });

      return uploadFilesParsedRows;
    }

    return [];
  };

  const renderTypeSelect = () => {
    // Create Options from assetsSpacesApiHistoryLogTypes
    const options = [
      assetsSpacesApiHistoryLogTypes.createFolder,
      assetsSpacesApiHistoryLogTypes.deleteFolder,
      assetsSpacesApiHistoryLogTypes.uploadFiles,
      assetsSpacesApiHistoryLogTypes.deleteFile,
      assetsSpacesApiHistoryLogTypes.deleteMultipleFiles,
    ];

    return (
      <Stack
        style={{
          justifyContent: "flex-end",
          marginBottom: 2,
        }}
      >
        <Autocomplete
          id="autocomplete-type"
          name="autocomplete-type"
          options={options}
          value={selectedType}
          onChange={(e, value) => {
            setSelectedType(value);
            setExpandedPanel(null);
          }}
          renderOption={(props, option) => (
            <li {...props} key={`type-${option}`}>
              <div
                style={{
                  fontFamily: "tmwCustomFont",
                  letterSpacing: 1,
                  fontSize: 10,
                }}
              >
                {option}
              </div>
            </li>
          )}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip
                variant="outlined"
                label={option}
                key={index}
                {...getTagProps({ index })}
                style={{
                  fontFamily: "tmwCustomFont",
                  letterSpacing: 1,
                  fontSize: 8,
                }}
              />
            ))
          }
          renderInput={(params) => (
            <>
              <TextField
                label="Filter: Type"
                id="selectedType"
                name="selectedType"
                fullWidth
                variant="standard"
                {...params}
                sx={{
                  width: "200px",
                  "& .MuiInput-underline:before": {
                    borderBottom: "1px solid #E6E6E6",
                  },
                  "& .MuiInput-underline:after": {
                    borderBottom: "1px solid black",
                  },
                  "& .css-dk8gfa-MuiSvgIcon-root-MuiSelect-icon": {
                    cursor: "pointer",
                  },
                  "& .MuiInputBase-input": {
                    paddingLeft: "10px",
                    fontSize: 10,
                    fontFamily: "tmwCustomFont",
                    letterSpacing: 1,
                  },
                  "& .MuiInputLabel-root": {
                    fontSize: 11,
                    color: "rgba(0, 0, 0, 0.6)", // default label color
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    fontSize: 11,
                    color: "rgba(0, 0, 0, 0.6)", // focused label color
                  },
                }}
              />
            </>
          )}
        />
      </Stack>
    );
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backdropFilter: "blur(5px)",
        zIndex: 1100,
      }}
    >
      <Box
        ref={modalRef}
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 1100,
          width: "80vw",
          height: "80vh",
        }}
      >
        <Container maxWidth="xxl">
          <Stack
            elevation={12}
            style={{
              background: "white",
              borderRadius: "25px",
              border: "1px solid #E6E6E6",
              height: "100%",
              width: "100%",
            }}
          >
            <Stack
              style={{
                height: "40px",
                background: "#39B349",
                borderRadius: "25px 25px 0 0",
              }}
            />
            <Stack
              direction="row"
              spacing={2}
              sx={{
                display: "flex",
                p: 3,
                width: "100%",
              }}
            >
              <Stack
                style={{
                  display: "flex",
                  flexDirection: "row",
                  height: "100%",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    height: "100%",
                    width: "100%",
                  }}
                >
                  <CustomTypography variant="h5" message={props?.title} title />
                  <Typography
                    color="text.secondary"
                    sx={{ mt: 1 }}
                    variant="body2"
                    style={{
                      fontFamily: "tmwCustomFont",
                      fontSize: 10,
                      color: "black",
                      letterSpacing: 1,
                      fontWeight: 400,
                      userSelect: "none",
                      textTransform: "uppercase",
                      wordBreak: "break-word",
                      whiteSpace: "normal",
                    }}
                  >
                    <p>
                      {"Current Folder: "}
                      <span style={{ fontWeight: "bold" }}>{path}</span>
                    </p>
                  </Typography>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      <CustomButton
                        label={"Current Folder"}
                        style={{
                          background: tab === 0 && "#E6E6E6",
                          borderRadius: 0,
                        }}
                        onClick={() => {
                          setTab(0);
                          setExpandedPanel(null);
                        }}
                      />
                      <CustomButton
                        label="All Folders"
                        style={{
                          background: tab === 1 && "#E6E6E6",
                          borderRadius: 0,
                        }}
                        onClick={() => {
                          setTab(1);
                          setExpandedPanel(null);
                        }}
                      />
                    </div>
                    <div>{renderTypeSelect()}</div>
                  </div>
                  <div
                    style={{
                      height: "100%",
                      width: "100%",
                    }}
                  >
                    {props.histories && (
                      <div
                        style={{
                          fontFamily: "tmwCustomFont",
                          letterSpacing: 1,
                          background: "white",
                          fontSize: 11,
                          fontWeight: 400,
                          border: "1px solid",
                          borderRadius: 0,
                          width: "100%",
                          height: "55vh",
                          overflow: "auto",
                        }}
                      >
                        {tab === 0 && (
                          <>
                            {currentFolderPathLogs?.length === 0 && (
                              <ul>
                                <li key={`history-no-imports`}>
                                  No history logs records
                                </li>
                              </ul>
                            )}
                            {currentFolderPathLogs?.map((object, index) => {
                              return (
                                <div
                                  key={`history-current-folder-${index}`}
                                  style={{
                                    width: "100%",
                                  }}
                                >
                                  <Accordion
                                    key={`history-current-folder-${index}`}
                                    expanded={
                                      expandedPanel ===
                                      `history-current-folder-${index}`
                                    }
                                    onChange={handleExpandChange(
                                      `history-current-folder-${index}`
                                    )}
                                    disabled={
                                      expandedPanel !== null &&
                                      expandedPanel !==
                                        `history-current-folder-${index}`
                                    }
                                    style={{
                                      width: "100%",
                                      borderRadius: 0,
                                    }}
                                  >
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                      aria-controls={`panel-${index}-content`}
                                      id={`panel-${index}-header`}
                                    >
                                      <Typography
                                        component="span"
                                        style={{
                                          fontFamily: "tmwCustomFont",
                                          fontSize: 12,
                                          color: "black",
                                          letterSpacing: 1,
                                          fontWeight: 400,
                                          userSelect: "none",
                                        }}
                                      >
                                        [
                                        {new Date(object.createdAt)
                                          .toLocaleDateString(
                                            "en-GB",
                                            dateOptions
                                          )
                                          .split("/")
                                          .join(".")}
                                        {` - ${object.type}`}
                                        ]: {`${object.path} (${object.user})`}
                                      </Typography>
                                      <Box
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          ml: "auto", // push to the right
                                          mr: 1, // small space before expand icon
                                          fontSize: 10,
                                          color: "inherit",
                                          lineHeight: 1,
                                          pointerEvents: "none",
                                        }}
                                      >
                                        [{currentFolderPathLogs.length - index}]
                                      </Box>
                                    </AccordionSummary>
                                    <Divider style={{ fontSize: 8 }}>
                                      OVERVIEW
                                    </Divider>
                                    <AccordionDetails>
                                      {expandedPanel ===
                                        `history-current-folder-${index}` && (
                                        <div>
                                          <DataGridPro
                                            disableColumnFilter
                                            disableDensitySelector
                                            sx={dataGridStyle}
                                            rows={rowsParser(
                                              object.type,
                                              object.data
                                            )}
                                            columns={columnsDefinition(
                                              object.type
                                            )}
                                            columnGroupingModel={columnGroupingModel(
                                              object.type
                                            )}
                                            experimentalFeatures={{
                                              columnGrouping: true,
                                            }}
                                            pagination
                                            getRowId={(row) => row.index}
                                          />
                                        </div>
                                      )}
                                    </AccordionDetails>
                                  </Accordion>
                                </div>
                              );
                            })}
                          </>
                        )}
                        {tab === 1 && (
                          <>
                            {allFoldersLogs?.length === 0 && (
                              <ul>
                                <li key={`history-no-imports`}>
                                  No history logs records
                                </li>
                              </ul>
                            )}
                            {allFoldersLogs?.map((object, index) => {
                              return (
                                <div
                                  key={`history-general-folder-${index}`}
                                  style={{
                                    width: "100%",
                                  }}
                                >
                                  <Accordion
                                    key={`history-general-folder-${index}`}
                                    expanded={
                                      expandedPanel ===
                                      `history-general-folder-${index}`
                                    }
                                    onChange={handleExpandChange(
                                      `history-general-folder-${index}`
                                    )}
                                    disabled={
                                      expandedPanel !== null &&
                                      expandedPanel !==
                                        `history-general-folder-${index}`
                                    }
                                    style={{
                                      width: "100%",
                                      borderRadius: 0,
                                    }}
                                  >
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                      aria-controls={`panel-${index}-content`}
                                      id={`panel-${index}-header`}
                                    >
                                      <Typography
                                        component="span"
                                        style={{
                                          fontFamily: "tmwCustomFont",
                                          fontSize: 12,
                                          color: "black",
                                          letterSpacing: 1,
                                          fontWeight: 400,
                                          userSelect: "none",
                                        }}
                                      >
                                        [
                                        {new Date(object.createdAt)
                                          .toLocaleDateString(
                                            "en-GB",
                                            dateOptions
                                          )
                                          .split("/")
                                          .join(".")}
                                        {` - ${object.type}`}
                                        ]: {`${object.path} (${object.user})`}
                                      </Typography>
                                      <Box
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          ml: "auto", // push to the right
                                          mr: 1, // small space before expand icon
                                          fontSize: 10,
                                          color: "inherit",
                                          lineHeight: 1,
                                          pointerEvents: "none",
                                        }}
                                      >
                                        [{allFoldersLogs.length - index}]
                                      </Box>
                                    </AccordionSummary>
                                    <Divider style={{ fontSize: 8 }}>
                                      OVERVIEW
                                    </Divider>
                                    <AccordionDetails>
                                      {expandedPanel ===
                                        `history-general-folder-${index}` && (
                                        <div>
                                          <DataGridPro
                                            disableColumnFilter
                                            disableDensitySelector
                                            sx={dataGridStyle}
                                            rows={rowsParser(
                                              object.type,
                                              object.data
                                            )}
                                            columns={columnsDefinition(
                                              object.type
                                            )}
                                            columnGroupingModel={columnGroupingModel(
                                              object.type
                                            )}
                                            experimentalFeatures={{
                                              columnGrouping: true,
                                            }}
                                            pagination
                                            getRowId={(row) => row.index}
                                          />
                                        </div>
                                      )}
                                    </AccordionDetails>
                                  </Accordion>
                                </div>
                              );
                            })}
                          </>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </Stack>
            </Stack>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                pb: 3,
                px: 3,
                gap: 2,
                marginTop: 3,
              }}
            >
              <CustomButton
                label={props?.cancelButtonLabel}
                color="inherit"
                sx={{ mr: 2 }}
                onClick={() => props?.cancelButton()}
              />
            </Box>
          </Stack>
        </Container>
      </Box>
    </div>
  );
};
